import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import TopicOutlinedIcon from '@mui/icons-material/TopicOutlined';
import DetailPage from './DetailPage';

const UserPage = () => {
  const field_icon = {
    title: <WorkOutlineOutlinedIcon className="detail-icon-" />,
    expertise: <TopicOutlinedIcon className="detail-icon-" />,
    affiliations: (
      <AccountBalanceOutlinedIcon className="detail-icon-" style={{ color: '#AB6EF9' }} />
    ),
    department: <AccountTreeOutlinedIcon className="detail-icon-" />,
    program: <AccountTreeOutlinedIcon className="detail-icon-" />,
    email: <AlternateEmailOutlinedIcon className="detail-icon-" style={{ color: '#4C90F6' }} />,
  };

  const url_icon = {
    resume: (
      <img
        src={`${process.env.PUBLIC_URL}/peopleIcons/cv.svg`}
        alt="resume"
        className="detail-icon clickable"
      />
    ),
    LinkedIn: (
      <img
        src={`${process.env.PUBLIC_URL}/peopleIcons/linkedin.svg`}
        alt="LinkedIn logo"
        className="detail-icon clickable"
      />
    ),
    ResearchGate: (
      <img
        src={`${process.env.PUBLIC_URL}/peopleIcons/ResearchGate.svg`}
        alt="ResearchGate logo"
        className="detail-icon clickable"
      />
    ),
    GoogleScholar: (
      <img
        src={`${process.env.PUBLIC_URL}/peopleIcons/googleScholar.svg`}
        alt="GoogleScholar logo"
        className="detail-icon clickable"
      />
    ),
    ORCID: (
      <img
        src={`${process.env.PUBLIC_URL}/peopleIcons/orcid.svg`}
        alt="ORCID logo"
        className="detail-icon clickable"
      />
    ),
    BlueSky: (
      <img
        src={`${process.env.PUBLIC_URL}/peopleIcons/BlueSky.svg`}
        alt="BlueSky logo"
        className="detail-icon clickable"
      />
    ),
    organization_url: (
      <img
        src={`${process.env.PUBLIC_URL}/peopleIcons/website.svg`}
        alt="Homepage logo"
        className="detail-icon clickable"
      />
    ),
  };

  const field_heading = {
    about: 'About',
    education: 'Educational Background',
    professional_experience: 'Professional Background',
  };

  return (
    <DetailPage
      category={'user'}
      heading={'display_name'}
      field_icon={field_icon}
      externalLink={{ field: 'homepage', text: 'Visit Homepage' }}
      field_heading={field_heading}
      url_icon={url_icon}
    />
  );
};

export default UserPage;
